import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import Carousel from '@homeaway/react-carousel';
import sentenceCase from '../../../utils/sentence-case';
import {createSerpLink} from '../../../utils/serp';
import {pushEdapEvent} from '../../../utils/edap';

import imageIds from './image-ids';
import {CarouselCard} from '../carousel-card/CarouselCard';

const keyPrefix = 'module.propertytypes';
const imageBaseUrl = 'https://odis.homeaway.com/odis/destination/';


export function handlerClick(propertyType) {
    const eventOptions = {
        actionlocation: 'property-types-module',
        eventrefinements: propertyType
    };

    const edapOptions = {delayProcessing: true};

    return () => pushEdapEvent('search.link.click', eventOptions, edapOptions);
}

function buildImageUrl(template) {
    const imageKey = template.replace('property_type_', '');
    const imageId = imageIds[imageKey];
    return (res) => `${imageBaseUrl}${imageId}.carousel-${res}.jpg`;
}

function createImageCard(intl, serpUrl, types) {
    const {formatMessage, formatNumber} = intl;

    return ({count, name, messageKey, params}) => {
        const msg = formatMessage({
            id: messageKey,
            defaultMessage: name
        });

        const title = sentenceCase(msg);

        const subtitle = formatMessage({
            id: `${keyPrefix}.tile.description.${messageKey}`
        });

        const footer = formatMessage(
            {id: `${keyPrefix}.tile.subtitle`},
            {
                propertyCount: formatNumber(count),
                propertyTypePluralNoArticle: msg
            }
        );

        return (
            <CarouselCard
                key={messageKey}
                baseClass={'full-image-card'}
                mkSrc={buildImageUrl(messageKey)}
                path={createSerpLink(serpUrl, params)}
                linkRel={'nofollow'}
                title={title}
                subtitle={subtitle}
                fullName={title}
                footer={footer}
                onClick={handlerClick(messageKey, types)}
            />
        );
    };
}


export class PropertyTypesComponent extends PureComponent {
    render() {
        const {
            propertyTypes,
            serpUrl,
            intl
        } = this.props;

        if (propertyTypes.length < 3) {
            return null;
        }

        const titleMessage = intl.formatMessage({id: `${keyPrefix}.title`});

        const cards = propertyTypes.map(
            createImageCard(intl, serpUrl)
        );

        return (
            <div className="container property-types">
                <h2 className="property-types__title">
                    {titleMessage}
                </h2>
                <Carousel className="property-types__carousel" pageSize={2}>
                    {cards}
                </Carousel>
            </div>
        );
    }
}


export function mapStateToProps({
    destination: {
        refinementsByType: {propertyTypes = []}
    },
    search: {serpUrl}
}) {
    return {
        propertyTypes: propertyTypes.filter(({count}) => count >= 15),
        serpUrl
    };
}


export const PropertyTypes = injectIntl(
    connect(mapStateToProps)(PropertyTypesComponent)
);
